import React from "react";
import { useLocation } from "react-router";
import { metaDefault } from "../../config/meta";
import { getString } from "../../utilities";
import BackToClassroom from "./backToClassroom";
import SchoolRfqForm from "./SchoolRfqForm";
import Lock from "../../../assets/svg/unlockColor.svg";
import Devices from "../../../assets/svg/devices.svg";

export default function SchoolForm() {
  const location = useLocation();

  return (
    <>
      {metaDefault({
        path: location.pathname,
        title: `${getString("subscribe.plans.school.requestQuote")} • ${getString("subscribe.plans.school.title.3")}`,
      })}

      <div className="school-form">
        <div className="wrapper padded">
          <h1>{getString("subscribe.plans.school.cta")}</h1>
        </div>

        <div className="wrapper school-form-info">
          <div className="plans-title">{getString("subscribe.plans.school.title.1")}</div>

          <ul className="plans-perks">
            <li>
              <Lock className="icon" />
              {getString("subscribe.plans.school.perksStripe.1")}
            </li>
            <li>
              <Devices className="icon" />
              {getString("subscribe.plans.school.perksStripe.2")}
            </li>
          </ul>

          <div className="school-form-info-cta">{getString("subscribe.plans.school.learnMore")}</div>

          <BackToClassroom />
        </div>

        <div className="wrapper padded odd">
          <div className="container-small">
            <SchoolRfqForm />
          </div>
        </div>
      </div>
      <div className="wrapper header-shadow" />
    </>
  );
}
